import React, { useContext } from 'react';
import { IconButton } from './m3';
import { ShellContext } from './shellContext';

/* ============================================================================
 * AdminTopBar — per-view header (title + subtitle + alert).
 * 검색·액션은 본문 ContentToolbar로 이동했다.
 * ========================================================================= */

export interface AdminTopBarProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  onToggleCollapse?: () => void;
  alertCount?: number;
}

export function AdminTopBar({
  title,
  subtitle,
  onToggleCollapse,
  alertCount,
}: AdminTopBarProps): React.ReactElement {
  const shell = useContext(ShellContext);
  const toggle = onToggleCollapse ?? shell.toggleCollapse;
  const alerts = alertCount ?? shell.alertCount;
  return (
    <header
      style={{
        height: 72,
        flexShrink: 0,
        padding: '0 28px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        borderBottom: '1px solid var(--md-sys-color-outline-variant)',
        background: 'var(--md-sys-color-surface)',
      }}
    >
      <IconButton icon="menu" onClick={toggle} title="사이드바 접기" style={{ marginLeft: -8 }} />

      <div style={{ minWidth: 0 }}>
        <div style={{ font: '700 21px/26px var(--gs-font-kr)', letterSpacing: -0.3, color: 'var(--md-sys-color-on-surface)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {title}
        </div>
        {subtitle != null && (
          <div style={{ font: '400 12px/16px var(--gs-font-kr)', color: 'var(--md-sys-color-on-surface-variant)' }}>
            {subtitle}
          </div>
        )}
      </div>

      <div style={{ flex: 1 }} />

      <div style={{ width: 1, height: 28, background: 'var(--md-sys-color-outline-variant)' }} />
      <div style={{ position: 'relative' }}>
        <IconButton icon="notifications" title="알림" />
        {alerts > 0 && (
          <span
            style={{
              position: 'absolute',
              top: 8,
              right: 8,
              width: 8,
              height: 8,
              borderRadius: 9999,
              background: 'var(--gs-warning)',
              boxShadow: '0 0 0 2px var(--md-sys-color-surface)',
            }}
          />
        )}
      </div>
    </header>
  );
}

/** Convenience helper for view scroll containers (matches prototype). */
export function ViewScroll({
  children,
  gap,
  style,
}: {
  children: React.ReactNode;
  gap?: number;
  style?: React.CSSProperties;
}): React.ReactElement {
  return (
    <div
      className="gs-scroll-hide"
      style={{
        flex: 1,
        overflowY: 'auto',
        padding: '20px 28px 40px',
        ...(gap != null ? { display: 'flex', flexDirection: 'column', gap } : {}),
        ...style,
      }}
    >
      {children}
    </div>
  );
}
